import { render, staticRenderFns } from "./BottomNavigationControl.vue?vue&type=template&id=5b9482ee&scoped=true&"
import script from "./BottomNavigationControl.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9482ee",
  null
  
)

export default component.exports